
import { useMeta } from 'quasar';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  setup() {
    useMeta({
      titleTemplate: (title) => `${title} - Memini`,
    });
  },
});
